var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useRef, useState, createRef } from 'react';
import html2canvas from 'html2canvas-add-mix-blend-mode';
import ProductSideButton from './components/ProductSideButton';
import SectionTitle from './components/SectionTitle';
import { Close } from './icons/Close';
import 'rc-slider/assets/index.css';
import { BackArrow } from './icons/BackArrow';
import formattedCurrency from '../helpers/currencyFormat';
import ProductPrice from './components/ProductPrice';
import s3 from '../helpers/awsConfig';
import cartUtil from '../helpers/cartUtil';
import ProductSide from './components/ProductSide';
import WarningPopup from './components/WarningPopup';
import FileSizePopup from './components/FileSizePopup';
import Lottie from 'react-lottie';
import * as finalLoaderData from '../../../assets/hg-final-loading.json';
import * as imageLoaderData from '../../../assets/hg-image-loading.json';
import FinalNets from './components/FinalNet';
import Checkbox from './components/Checkbox';
import LoadingText from './components/LoadingText';
import ExportCanvas from './components/ExportCanvas';
import { PDFDocument } from 'pdf-lib';
import ExtraSideButton from './components/ExtraSideButton';
import PreviewTile from './components/PreviewTile';
import QuantitySelect from './components/QuantitySelect';
import ErrorPopupLayout from './layouts/ErrorPopupLayout';
const CustomiseModal = ({ product, env, display, handler, strings, templateStrings, currentVariant, currentFilterOptions, settings, updateCurrentVariant, }) => {
    var _a, _b;
    const initializeState = (defaultValue) => {
        return currentVariant.sides.reduce((acc, side) => {
            acc[side.side_name] = defaultValue;
            return acc;
        }, {});
    };
    const initializeNetState = () => {
        return currentVariant.nets.map((net) => {
            return {
                name: net.net_name,
                pdf_file: net.pdf_file,
                width: net.width,
                height: net.height,
                images: [],
            };
        });
    };
    const initializeCanvasState = () => {
        return currentVariant.sides.reduce((acc, side) => {
            acc[side.side_name] = {
                width: Number(side.canvas_width),
                height: Number(side.canvas_height),
                widthMM: Number(side.canvas_width),
                heightMM: Number(side.canvas_height),
            };
            return acc;
        }, {});
    };
    const finalLoader = {
        loop: true,
        autoplay: true,
        animationData: finalLoaderData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };
    const imageLoader = {
        loop: true,
        autoplay: true,
        animationData: imageLoaderData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };
    const productHandle = product.handle;
    const [uniqueID, setUniqueID] = useState(null);
    const [globalFolderName, setGlobalFolderName] = useState(null);
    // Modal state
    const [currentSide, setCurrentSide] = useState(currentVariant.sides[0].side_name);
    const [currentSideDetail, setCurrentSideDetail] = useState(currentVariant.sides[0]);
    // Extra sides state
    const [extrasAdded, setExtrasAdded] = useState(false);
    const [productOptionKeys] = useState(product.options.map((option) => option.name));
    const [filter] = useState(product.options.map((option) => option.name).includes('Colour') ? 'Colour' : 'Quantity');
    const [extraSides] = useState(currentVariant.sides.filter((side) => side.print_side == 'Double').map((side) => side.side_name));
    // Variants state
    const [currentSelectedFilter, setCurrentSelectedFilter] = useState(currentFilterOptions.find((variant) => variant.options == currentVariant.options));
    // Pricing state
    const [basePricePerItem, setBasePricePerItem] = useState(null);
    const [baseUnitPrice, setBaseUnitPrice] = useState(0);
    const [baseCurrentVariantSaving, setBaseCurrentVariantSaving] = useState(0);
    // Uploaded Image state
    const [uploadedImages, setUploadedImages] = useState(initializeState([]));
    const [imageDimensions, setImageDimensions] = useState(initializeState([]));
    const [netImageData, setNetImageData] = useState(initializeNetState());
    const [canvasPreviews, setCanvasPreviews] = useState(initializeState(null));
    // Canvas state
    const [canvasDimensions, setCanvasDimensions] = useState(initializeCanvasState());
    const [fileTypeError, setFileTypeError] = useState({ isError: false, timestamp: Date.now() });
    const [fileSizeError, setFileSizeError] = useState({ isError: false, timestamp: Date.now() });
    const [fileLargeError, setFileLargeError] = useState({ isError: false, timestamp: Date.now() });
    const [fileSmallError, setFileSmallError] = useState({ isError: false, timestamp: Date.now() });
    const [maxUploadsError, setMaxUploadsError] = useState({ isError: false, timestamp: Date.now() });
    const [currentWindow, setCurrentWindow] = useState('first');
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [selectedImages, setSelectedImages] = useState(initializeState(null));
    const finalCanvasRefs = useRef(currentVariant.sides.map(() => createRef()));
    // Loading state
    const [isLoading, setIsLoading] = useState(false);
    const [imageUploading, setImageUploading] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    // Net State
    const [scaleMultiplier, setScaleMultiplier] = useState(initializeState(0));
    const netRef = useRef(null);
    // Warnings state
    const [uploadAttempt, setUploadAttempt] = useState(0);
    const [showWarningPopup, setShowWarningPopup] = useState(false);
    const [uploadFailed, setUploadFailed] = useState(false);
    // Cart state
    const [cartState, setCartState] = useState(filter == 'Colour' || filter == 'Color' ? [] : [{ id: currentVariant.id, quantity: 1 }]);
    const [cartPrices, setCartPrices] = useState({ withDiscount: 0, combinedTotal: 0, discount: 0 });
    const [cartCombinedQty, setCartCombinedQty] = useState(0);
    useEffect(() => {
        // set uuid to the date and time and seconds
        const date = new Date();
        const formattedDate = date.toLocaleDateString('en-AU').split('/').join('-');
        const formattedTime = date.toLocaleTimeString('en-AU', { hour12: false });
        const uuid = `${formattedDate}-${formattedTime}`;
        setUniqueID(uuid);
        setGlobalFolderName(productHandle + '-' + uuid);
        // setGlobalFolderName('000000-AAAAAA__Testing');
    }, []);
    useEffect(() => {
        // Block page refresh if images have been uploaded
        const hasUploadedImages = Object.values(uploadedImages).some((image) => image.length > 0);
        if (hasUploadedImages && display) {
            // HG-354 Stop page refresh: Disabling for now
            // window.addEventListener('beforeunload', onConfirmRefresh, true);
        }
    }, [uploadedImages]);
    useEffect(() => {
        setCurrentSelectedFilter(currentFilterOptions.filter((variant) => variant.options == currentVariant.options)[0]);
    }, [currentFilterOptions, currentVariant]);
    useEffect(() => {
        // Set base price per box
        const removeSample = currentFilterOptions.filter((option) => !option.options[productOptionKeys.indexOf(filter)].includes('Sample') &&
            option.options[productOptionKeys.indexOf('_print')] != 'Double');
        const lowestQty = removeSample.reduce((prev, curr) => prev.options[productOptionKeys.indexOf(filter)] < curr.options[productOptionKeys.indexOf(filter)] ? prev : curr);
        const highestPricePerItem = lowestQty.price / Number(lowestQty.options[productOptionKeys.indexOf(filter)]);
        const currentFilterVariant = currentSelectedFilter.options[productOptionKeys.indexOf(filter)];
        const singleVariant = currentFilterOptions.find((option) => option.options[productOptionKeys.indexOf(filter)] == currentFilterVariant &&
            option.options[productOptionKeys.indexOf('_print')] == 'Single');
        const doubleVariant = currentFilterOptions.find((option) => option.options[productOptionKeys.indexOf(filter)] == currentFilterVariant &&
            option.options[productOptionKeys.indexOf('_print')] == 'Double');
        setBasePricePerItem(highestPricePerItem);
        if (singleVariant && doubleVariant) {
            const qntMultiplier = currentFilterVariant.includes('Sample') || filter != 'Quantity' ? 1 : currentFilterVariant;
            const price = (doubleVariant.price - singleVariant.price) / qntMultiplier;
            setBaseUnitPrice(price);
        }
    }, [currentSelectedFilter]);
    // Function to handle the image upload
    const handleImageUpload = (imageUrl, height, width, error) => {
        // Increment upload attempt counter on every upload attempt
        setUploadAttempt((prevAttempt) => prevAttempt + 1);
        if (error == 'fileType') {
            setFileTypeError({ isError: true, timestamp: Date.now() });
        }
        else if (error == 'fileSize') {
            setFileSizeError({ isError: true, timestamp: Date.now() });
        }
        else if (error == 'fileLarge') {
            setFileLargeError({ isError: true, timestamp: Date.now() });
        }
        else if (error == 'fileSmall') {
            setFileSmallError({ isError: true, timestamp: Date.now() });
        }
        else if (error == 'maxUploads') {
            setMaxUploadsError({ isError: true, timestamp: Date.now() });
        }
        else {
            // Reset error states on successful upload
            setFileTypeError({ isError: false, timestamp: Date.now() });
            setFileSizeError({ isError: false, timestamp: Date.now() });
            setFileLargeError({ isError: false, timestamp: Date.now() });
            setFileSmallError({ isError: false, timestamp: Date.now() });
            setMaxUploadsError({ isError: false, timestamp: Date.now() });
            const newImageIndex = uploadedImages[currentSide].length;
            setUploadedImages((prevImages) => (Object.assign(Object.assign({}, prevImages), { [currentSide]: [...prevImages[currentSide], imageUrl] })));
            updateImageDimensions(newImageIndex, width, height, true);
            setSelectedImagePerSide(currentSide, newImageIndex);
            // Set extras added if this is a double print side
            if (currentSideDetail.print_side == 'Double') {
                setExtrasAdded(true);
            }
        }
        setImageUploading(false);
    };
    useEffect(() => {
        // Set current selected
        if (productOptionKeys.includes('_print')) {
            if (extrasAdded == true) {
                setCurrentSelectedFilter(currentFilterOptions.find((variant) => variant.options[productOptionKeys.indexOf(filter)] ==
                    currentSelectedFilter.options[productOptionKeys.indexOf(filter)] &&
                    variant.options[productOptionKeys.indexOf('_print')] == 'Double'));
            }
            else {
                setCurrentSelectedFilter(currentFilterOptions.find((variant) => variant.options[productOptionKeys.indexOf(filter)] ==
                    currentSelectedFilter.options[productOptionKeys.indexOf(filter)] &&
                    variant.options[productOptionKeys.indexOf('_print')] == 'Single'));
            }
        }
        // Update cart
        if (cartState.length) {
            const currentCart = product.variants.filter((variant) => cartState.find((cartItem) => cartItem.id == variant.id));
            const variantsToAdd = [];
            currentCart.forEach((cartItem) => {
                if (extrasAdded == true) {
                    const variantToAdd = product.variants.find((variant) => variant.options[productOptionKeys.indexOf(filter)] ==
                        cartItem.options[productOptionKeys.indexOf(filter)] &&
                        variant.options[productOptionKeys.indexOf('Size')] ==
                            cartItem.options[productOptionKeys.indexOf('Size')] &&
                        variant.options[productOptionKeys.indexOf('_print')] == 'Double');
                    variantsToAdd.push(variantToAdd);
                }
                else {
                    const variantToAdd = product.variants.find((variant) => variant.options[productOptionKeys.indexOf(filter)] ==
                        cartItem.options[productOptionKeys.indexOf(filter)] &&
                        variant.options[productOptionKeys.indexOf('Size')] ==
                            cartItem.options[productOptionKeys.indexOf('Size')] &&
                        variant.options[productOptionKeys.indexOf('_print')] == 'Single');
                    variantsToAdd.push(variantToAdd);
                }
            });
            setCartState((prevCart) => {
                return prevCart.map((cartItem) => {
                    const currentItem = currentCart.find((item) => item.id == cartItem.id);
                    const currentIndex = currentCart.indexOf(currentItem);
                    return Object.assign(Object.assign({}, cartItem), { id: variantsToAdd[currentIndex].id });
                });
            });
        }
    }, [extrasAdded]);
    const updateCurrentVariantInit = (newVariant) => {
        updateCurrentVariant(newVariant);
        if (filter == 'Colour' || filter == 'Color') {
            // if colour filter, update the cartState
            const currentCart = product.variants.filter((variant) => cartState.find((cartItem) => cartItem.id == variant.id));
            const variantsToAdd = [];
            currentCart.forEach((cartItem) => {
                const variantToAdd = product.variants.find((variant) => variant.options[productOptionKeys.indexOf(filter)] != cartItem.options[productOptionKeys.indexOf(filter)] &&
                    variant.options[productOptionKeys.indexOf('Size')] == cartItem.options[productOptionKeys.indexOf('Size')] &&
                    variant.options[productOptionKeys.indexOf('_print')] ==
                        cartItem.options[productOptionKeys.indexOf('_print')]);
                variantsToAdd.push(variantToAdd);
            });
            setCartState((prevCart) => {
                return prevCart.map((cartItem) => {
                    const currentItem = currentCart.find((item) => item.id == cartItem.id);
                    const currentIndex = currentCart.indexOf(currentItem);
                    return Object.assign(Object.assign({}, cartItem), { id: variantsToAdd[currentIndex].id });
                });
            });
        }
    };
    const reorderImagesOnSide = (newUploadedImages, newImageDimensions) => {
        setUploadedImages((prevImages) => (Object.assign(Object.assign({}, prevImages), { [currentSide]: newUploadedImages })));
        setImageDimensions((preDimensions) => (Object.assign(Object.assign({}, preDimensions), { [currentSide]: newImageDimensions })));
    };
    // Function to remove the image from the canvas
    const handleImageRemove = (imageIndex, imageURL, side) => {
        removeImageFromS3(imageIndex, imageURL, side);
        setSelectedImagePerSide(currentSide, null);
    };
    const removeExtras = (side) => {
        setSelectedImagePerSide(side, null);
        uploadedImages[side].forEach((img, index) => {
            handleImageRemove(index, img, side);
        });
    };
    const calculateCanvasSize = (sideName, packagingImageWidth) => {
        const [side] = currentVariant.sides.filter((side) => side.side_name == sideName);
        const canvasWMM = Number(side.canvas_width);
        const canvasHMM = Number(side.canvas_height);
        const packagingWidthMM = Number(side.canvas_width) + Number(side.canvas_left) + Number(side.canvas_right);
        const multiplier = packagingImageWidth / packagingWidthMM;
        const scaler = packagingImageWidth / packagingWidthMM;
        setScaleMultiplier((scales) => (Object.assign(Object.assign({}, scales), { [side.side_name]: scaler })));
        return setCanvasDimensions((preDimensions) => (Object.assign(Object.assign({}, preDimensions), { [side.side_name]: {
                width: canvasWMM * multiplier,
                height: canvasHMM * multiplier,
                widthMM: canvasWMM,
                heightMM: canvasHMM,
            } })));
    };
    // Function to remove the image from S3 and update state
    const removeImageFromS3 = (imageIndex, imageUrl, side) => {
        const fileName = imageUrl.split('/').pop(); // Extract file name from URL
        const deleteParams = {
            Bucket: 'heapsgood-packaging',
            Key: fileName,
        };
        s3.deleteObject(deleteParams, (err, data) => {
            if (err) {
                console.error('Error deleting the file from S3: ', err.message);
            }
            else {
                console.log('File deleted successfully from S3');
                const updatedImages = uploadedImages[side];
                const updatedImagesRemoved = updatedImages.splice(imageIndex, 1);
                const updatedDimensions = imageDimensions[side];
                const updatedDimensionsRemoved = updatedDimensions.splice(imageIndex, 1);
                setUploadedImages((prevImages) => (Object.assign(Object.assign({}, prevImages), { [side]: updatedImages })));
                setImageDimensions((preDimensions) => (Object.assign(Object.assign({}, preDimensions), { [side]: updatedDimensions })));
                // Remove extras pricing if no images left on the side
                const activeSide = currentVariant.sides.find((variantSide) => variantSide.side_name == side);
                if (updatedImages.length == 0 && activeSide.print_side == 'Double') {
                    setExtrasAdded(false);
                }
            }
        });
    };
    // Function to switch the current side
    const displaySide = (side) => {
        setCurrentSide(side);
        setCurrentSideDetail(currentVariant.sides.find((variantSide) => variantSide.side_name == side));
    };
    // Function to update image dimensions
    const updateImageDimensions = (imageIndex, width, height, onload) => {
        let imageWidth = width;
        let imageHeight = height;
        if (width >= height) {
            if (canvasDimensions[currentSide].width < width) {
                imageWidth = canvasDimensions[currentSide].width;
                const multiplier = canvasDimensions[currentSide].width / width;
                imageHeight = height * multiplier;
            }
        }
        else if (height > width) {
            if (canvasDimensions[currentSide].height < height) {
                imageHeight = canvasDimensions[currentSide].height;
                const multiplier = canvasDimensions[currentSide].height / height;
                imageWidth = width * multiplier;
            }
        }
        const newDimensions = {
            width: imageWidth,
            widthMM: Math.round(imageWidth / scaleMultiplier[currentSide]),
            height: imageHeight,
            heightMM: Math.round(imageHeight / scaleMultiplier[currentSide]),
            aspectRatio: width / height,
            position: {
                x: !!onload
                    ? canvasDimensions[currentSide].width / 2 - imageWidth / 2
                    : imageDimensions[currentSide][imageIndex].position.x,
                y: !!onload
                    ? canvasDimensions[currentSide].height / 2 - imageHeight / 2
                    : imageDimensions[currentSide][imageIndex].position.y,
                rotation: !!onload ? 0 : imageDimensions[currentSide][imageIndex].position.rotation,
            },
        };
        let newImageDimensions = imageDimensions[currentSide];
        if (!!onload) {
            // New image
            newImageDimensions = [...imageDimensions[currentSide], newDimensions];
        }
        else {
            newImageDimensions[imageIndex] = newDimensions;
        }
        setImageDimensions((preDimensions) => (Object.assign(Object.assign({}, preDimensions), { [currentSide]: newImageDimensions })));
    };
    const updateImageScale = (imageIndex, dimension, newValue) => {
        let newHeightMM, newWidthMM;
        if (imageIndex == null) {
            return;
        }
        if (dimension == 'width') {
            newHeightMM = Math.round(((newValue / imageDimensions[currentSide][imageIndex].aspectRatio) * 100) / 100);
            newWidthMM = newValue;
        }
        else {
            newWidthMM = Math.round(((newValue / imageDimensions[currentSide][imageIndex].aspectRatio) * 100) / 100);
            newHeightMM = newValue;
        }
        const newDimensions = Object.assign(Object.assign({}, imageDimensions[currentSide][imageIndex]), { width: newWidthMM * scaleMultiplier[currentSide], widthMM: newWidthMM, height: newHeightMM * scaleMultiplier[currentSide], heightMM: newHeightMM });
        let newImageDimensions = imageDimensions[currentSide];
        newImageDimensions[imageIndex] = newDimensions;
        setImageDimensions((preDimensions) => (Object.assign(Object.assign({}, preDimensions), { [currentSide]: newImageDimensions })));
    };
    // Function to update the position for a side
    const updatePosition = (imageIndex, side, newPosition) => {
        const newDimensions = Object.assign(Object.assign({}, imageDimensions[currentSide][imageIndex]), { position: newPosition });
        let newImageDimensions = imageDimensions[currentSide];
        newImageDimensions[imageIndex] = newDimensions;
        setImageDimensions((prevDimensions) => (Object.assign(Object.assign({}, prevDimensions), { [side]: newImageDimensions })));
    };
    // Function to align the image inside the canvas
    const handleAlignment = (selectedImage, direction) => {
        const newPos = Object.assign({}, imageDimensions[currentSide][selectedImage].position);
        const currentWidth = imageDimensions[currentSide][selectedImage].width;
        const currentHeight = imageDimensions[currentSide][selectedImage].height;
        switch (direction) {
            case 'Left':
                newPos.x = 0;
                break;
            case 'Top':
                newPos.y = 0;
                break;
            case 'Vertical Centre':
                newPos.y = canvasDimensions[currentSide].height / 2 - currentHeight / 2;
                break;
            case 'Horizontal Centre':
                newPos.x = canvasDimensions[currentSide].width / 2 - currentWidth / 2;
                break;
            case 'Right':
                newPos.x = canvasDimensions[currentSide].width - currentWidth;
                break;
            case 'Bottom':
                newPos.y = canvasDimensions[currentSide].height - currentHeight;
                break;
            default:
                break;
        }
        updatePosition(selectedImage, currentSide, newPos);
    };
    const captureCanvasImages = () => __awaiter(void 0, void 0, void 0, function* () {
        const nets = initializeNetState();
        const canvasImages = initializeState(null);
        currentVariant.sides.forEach((sideData, index) => __awaiter(void 0, void 0, void 0, function* () {
            const side = sideData.side_name;
            const finalCanvas = finalCanvasRefs.current[index];
            if (!finalCanvas)
                return null;
            const canvas = finalCanvas.current;
            const netSide = Number(sideData.net_pdf_file) - 1;
            // Capture net data if available and append it to the nets structure.
            if (canvas) {
                // @ts-ignore
                const canvasData = yield canvas.toDataURL();
                const netData = {
                    dataUrl: canvasData ? canvasData : '',
                    top: sideData.net_position_top,
                    left: sideData.net_position_left,
                    width: sideData.canvas_width,
                    height: sideData.canvas_height,
                    rotation: sideData.net_rotation,
                };
                nets[netSide].images.push(netData);
                canvasImages[side] = canvasData;
            }
        }));
        yield setNetImageData(nets);
        yield setCanvasPreviews(canvasImages);
    });
    const capturePreviewImages = () => __awaiter(void 0, void 0, void 0, function* () {
        let previewImageData = '';
        let thumbnailImageData = '';
        const allNets = [];
        // Capture Preview
        const previewCanvas = document.querySelector(`[data-hg-preview-canvas=""`);
        if (previewCanvas) {
            try {
                const packagingCanvas = yield html2canvas(previewCanvas, {
                    useCORS: true,
                    logging: true,
                });
                previewImageData = packagingCanvas.toDataURL();
            }
            catch (error) {
                console.error('Error capturing preview with html2canvas:', error);
            }
        }
        // Capture Thumbnail
        const firstSide = currentVariant.sides[0];
        const side = firstSide.side_name;
        const thumbnailDiv = document.querySelector(`[data-hg-preview-image="${side}"]`);
        if (thumbnailDiv) {
            try {
                const packagingCanvas = yield html2canvas(thumbnailDiv, {
                    useCORS: true,
                    logging: true,
                });
                thumbnailImageData = packagingCanvas.toDataURL();
            }
            catch (error) {
                console.error('Error capturing thumbnail with html2canvas:', error);
            }
        }
        // Final Nets
        const finalFrames = netRef.current.querySelectorAll('[data-final-net]');
        const captureNet = (index) => __awaiter(void 0, void 0, void 0, function* () {
            const netDims = netImageData[index];
            // Leaving this here, this converts px to mm
            // const pdfMultiplier = 2.8346666667;
            const pdfMultiplier = 10;
            const frame = finalFrames[index];
            let netData = null;
            try {
                const netImage = yield html2canvas(frame, {
                    useCORS: true,
                    logging: true,
                    backgroundColor: null,
                });
                const pngImageBytes = netImage.toDataURL();
                if (settings.file_output_type == 'PDF') {
                    const pdfDoc = yield PDFDocument.create();
                    const pngImage = yield pdfDoc.embedPng(pngImageBytes);
                    const page = pdfDoc.addPage([Number(netDims.width) * pdfMultiplier, Number(netDims.height) * pdfMultiplier]);
                    page.drawImage(pngImage, {
                        x: 0,
                        y: 0,
                        width: Number(netDims.width) * pdfMultiplier,
                        height: Number(netDims.height) * pdfMultiplier,
                    });
                    const base64DataUri = yield pdfDoc.saveAsBase64({ dataUri: true });
                    netData = base64DataUri;
                }
                else {
                    netData = pngImageBytes;
                }
            }
            catch (error) {
                console.error('Error capturing packagingDiv with html2canvas:', error);
            }
            allNets[index] = netData;
        });
        if (!extrasAdded) {
            // Only first
            yield captureNet(0);
        }
        else {
            for (let index = 0; index < finalFrames.length; index++) {
                yield captureNet(index);
            }
        }
        return {
            preview: previewImageData,
            thumb: thumbnailImageData,
            nets: allNets,
        };
    });
    const changeWindowHandler = () => {
        const isCurrentWindowFirst = currentWindow === 'first';
        setCurrentWindow(isCurrentWindowFirst ? 'second' : 'first');
        setPreviewLoading(false);
    };
    const changeQty = (qtyObject) => {
        setCurrentSelectedFilter(qtyObject);
        if (cartState.length) {
            const currentCart = product.variants.filter((variant) => cartState.find((cartItem) => cartItem.id == variant.id));
            const variantsToAdd = [];
            currentCart.forEach((cartItem) => {
                const variantToAdd = product.variants.find((variant) => variant.options[productOptionKeys.indexOf(filter)] ==
                    qtyObject.options[productOptionKeys.indexOf(filter)] &&
                    variant.options[productOptionKeys.indexOf('Size')] == cartItem.options[productOptionKeys.indexOf('Size')] &&
                    variant.options[productOptionKeys.indexOf('_print')] ==
                        cartItem.options[productOptionKeys.indexOf('_print')]);
                variantsToAdd.push(variantToAdd);
            });
            setCartState((prevCart) => {
                return prevCart.map((cartItem) => {
                    const currentItem = currentCart.find((item) => item.id == cartItem.id);
                    const currentIndex = currentCart.indexOf(currentItem);
                    return Object.assign(Object.assign({}, cartItem), { id: variantsToAdd[currentIndex].id });
                });
            });
        }
    };
    const uploadToImageS3 = (blob, fileName, type) => __awaiter(void 0, void 0, void 0, function* () {
        const params = {
            Bucket: 'heapsgood-packaging',
            Key: fileName,
            Body: blob,
            ContentType: 'image/png',
            ACL: 'public-read',
        };
        try {
            const uploadResult = yield s3.upload(params).promise();
            console.log(`Upload Success: ${type}`);
            return uploadResult.Location; // S3 URL of the uploaded file
        }
        catch (error) {
            console.error(`Upload Error: ${type}`, error);
            throw error;
        }
    });
    const dataURItoBlob = (dataURI) => {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
            type: 'application/pdf',
        });
    };
    const uploadToPDFS3 = (base64PDF, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        let parsedPDF = dataURItoBlob(base64PDF);
        const params = {
            Bucket: 'heapsgood-packaging',
            Key: fileName,
            Body: parsedPDF,
            ContentType: 'application/pdf',
            ACL: 'public-read',
        };
        try {
            const uploadResult = yield s3.upload(params).promise();
            console.log('Upload Success: Net PDF');
            return uploadResult.Location; // S3 URL of the uploaded file
        }
        catch (error) {
            console.error('Upload Error: Net PDF', error);
            throw error;
        }
    });
    const editImageHandler = (side) => {
        setCurrentWindow('first');
        setCurrentSide(side);
        setCurrentSideDetail(currentVariant.sides.find((variantSide) => variantSide.side_name == side));
    };
    const goToNextScreen = () => {
        setPreviewLoading(true);
        const goToNext = () => __awaiter(void 0, void 0, void 0, function* () {
            yield captureCanvasImages()
                .then(() => {
                changeWindowHandler();
            })
                .catch((error) => {
                console.error('Error during image capture:', error);
                setPreviewLoading(false);
            });
        });
        setTimeout(goToNext, 100);
    };
    const closeWarningPopup = () => {
        setShowWarningPopup(false);
    };
    const closeModalAndReset = () => {
        handler();
    };
    const onConfirmRefresh = useCallback((event) => {
        event.preventDefault();
        return (event.returnValue = 'Are you sure you want to leave the page?');
    }, []);
    const handleCloseButtonClick = () => {
        const hasUploadedImages = Object.values(uploadedImages).some((image) => image.length > 0);
        if (hasUploadedImages) {
            setShowWarningPopup(true);
        }
        else {
            handler();
        }
    };
    const resetErrorChecks = () => {
        setUploadFailed(false);
        setFileTypeError({ isError: false, timestamp: Date.now() });
        setFileSizeError({ isError: false, timestamp: Date.now() });
        setFileLargeError({ isError: false, timestamp: Date.now() });
        setFileSmallError({ isError: false, timestamp: Date.now() });
    };
    const setSelectedImagePerSide = (side, imageIndex) => {
        setSelectedImages((prevState) => (Object.assign(Object.assign({}, prevState), { [side]: imageIndex })));
    };
    // Function to uploaded the captured canvas images to s3
    const uploadSideCanvasImagesToS3 = () => __awaiter(void 0, void 0, void 0, function* () {
        Object.entries(canvasPreviews).map(([sideName, dataImage], index) => {
            const uploadCanvas = () => __awaiter(void 0, void 0, void 0, function* () {
                if (dataImage) {
                    const blob = yield fetch(dataImage).then((res) => res.blob());
                    const fileName = `side-capture_${index + 1}_${uniqueID}.png`;
                    const folderName = `${globalFolderName}/side-image`;
                    const uploadParams = {
                        Bucket: 'heapsgood-packaging',
                        Key: `${folderName}/${fileName}`,
                        Body: blob,
                        ContentType: 'image/png',
                        ACL: 'public-read',
                    };
                    try {
                        const uploadResult = yield s3.upload(uploadParams).promise();
                        console.log('Upload Success: Side Artwork');
                    }
                    catch (err) {
                        console.error('Upload Error: Side Artwork', err.message);
                    }
                }
            });
            if (!extrasAdded) {
                if (!extraSides.includes(sideName)) {
                    // only upload single sides
                    uploadCanvas();
                }
            }
            else {
                // Upload all
                uploadCanvas();
            }
        });
    });
    // Function to delete folder from s3 when closing the modal
    const deleteFolderContents = (folderName) => __awaiter(void 0, void 0, void 0, function* () {
        const listParams = {
            Bucket: 'heapsgood-packaging',
            Prefix: `${folderName}/`,
        };
        try {
            const listedObjects = yield s3.listObjectsV2(listParams).promise();
            if (listedObjects.Contents.length === 0)
                return;
            const deleteParams = {
                Bucket: 'heapsgood-packaging',
                Delete: { Objects: [] },
            };
            listedObjects.Contents.forEach(({ Key }) => {
                deleteParams.Delete.Objects.push({ Key });
            });
            yield s3.deleteObjects(deleteParams).promise();
            if (listedObjects.IsTruncated)
                yield deleteFolderContents(folderName);
            console.log(`Successfully deleted all objects in folder ${folderName}`);
        }
        catch (err) {
            console.error('Error deleting objects in folder:', folderName, err.message);
        }
    });
    const formatPrice = (combinedPrices, discountAmount) => __awaiter(void 0, void 0, void 0, function* () {
        const discountCost = combinedPrices * (discountAmount / 100);
        const withDiscount = combinedPrices - discountCost;
        setCartPrices({
            combinedTotal: combinedPrices,
            withDiscount: withDiscount,
            discount: discountAmount,
        });
    });
    useEffect(() => {
        if (cartState.length) {
            const combinedPrices = cartState.reduce((acc, obj) => {
                const currentVariant = product.variants.find((variant) => variant.id == obj.id);
                if (currentVariant) {
                    const variantPrice = obj.quantity * currentVariant.price;
                    return acc + variantPrice;
                }
            }, 0);
            const combinedQty = cartState.reduce((acc, obj) => {
                return acc + obj.quantity;
            }, 0);
            setCartCombinedQty(combinedQty);
            if (settings.enable_hg_c_disc) {
                if (settings.tier_five_enable && combinedQty >= settings.tier_five_qty) {
                    formatPrice(combinedPrices, settings.tier_five_disc);
                }
                else if (settings.tier_four_enable && combinedQty >= settings.tier_four_qty) {
                    formatPrice(combinedPrices, settings.tier_four_disc);
                }
                else if (settings.tier_three_enable && combinedQty >= settings.tier_three_qty) {
                    formatPrice(combinedPrices, settings.tier_three_disc);
                }
                else if (settings.tier_two_enable && combinedQty >= settings.tier_two_qty) {
                    formatPrice(combinedPrices, settings.tier_two_disc);
                }
                else if (combinedQty >= settings.tier_one_qty) {
                    formatPrice(combinedPrices, settings.tier_one_disc);
                }
                else {
                    formatPrice(combinedPrices, 0);
                }
            }
            else {
                formatPrice(combinedPrices, 0);
            }
        }
        else {
            formatPrice(0, 0);
            setCartCombinedQty(0);
        }
    }, [cartState]);
    // Color only
    const updateCartState = (variantID, quantity) => {
        const inCart = cartState.find((cartItem) => cartItem.id == variantID);
        if (inCart) {
            const updateIndex = cartState.indexOf(inCart);
            const updatedCartState = cartState;
            if (quantity <= 0) {
                // remove from cart object and disable
                const removeFromCart = updatedCartState.splice(updateIndex, 1);
                setCartState([...updatedCartState]);
            }
            else {
                updatedCartState[updateIndex] = {
                    id: variantID,
                    quantity: quantity,
                };
                setCartState([...updatedCartState]);
            }
        }
        else {
            if (quantity == 0 || quantity < 0) {
                return;
            }
            setCartState([
                ...cartState,
                {
                    id: variantID,
                    quantity: quantity,
                },
            ]);
        }
    };
    const initAddToCart = () => {
        setIsLoading(true);
    };
    useEffect(() => {
        if (isLoading == true) {
            setTimeout(() => {
                addToCart();
            }, 100);
        }
    }, [isLoading]);
    const addToCart = () => __awaiter(void 0, void 0, void 0, function* () {
        const folderNameUid = productHandle + '-' + uniqueID;
        uploadSideCanvasImagesToS3();
        yield capturePreviewImages()
            .then((imageData) => __awaiter(void 0, void 0, void 0, function* () {
            let previewURL = '';
            let thumbnailURL = '';
            let finalNetUrls = [];
            // Save preview image
            const previewImageS3Key = `${globalFolderName}/preview-image.png`;
            const previewImageBlob = yield fetch(imageData.preview).then((res) => res.blob());
            const packagingDataUrlS3Url = yield uploadToImageS3(previewImageBlob, previewImageS3Key, 'Preview Image');
            previewURL = packagingDataUrlS3Url;
            // Save thumbnail image
            const thumbnailImageS3Key = `${globalFolderName}/thumbnail-image.png`;
            const thumbnailImageBlob = yield fetch(imageData.thumb).then((res) => res.blob());
            const thumbnailDataUrlS3Url = yield uploadToImageS3(thumbnailImageBlob, thumbnailImageS3Key, 'Thumbnail Image');
            thumbnailURL = thumbnailDataUrlS3Url;
            // Iterate through nets to upload each net with the images placed
            for (let index = 0; index < imageData.nets.length; index++) {
                const currentNet = imageData.nets[index];
                const netS3Key = `${globalFolderName}/net-image/net-image__${index + 1}--${uniqueID}.${settings.file_output_type.toLowerCase()}`;
                if (settings.file_output_type == 'PDF') {
                    // pdf upload
                    const netS3Url = yield uploadToPDFS3(currentNet, netS3Key);
                    finalNetUrls[index] = netS3Url;
                }
                else {
                    // png upload
                    const canvasImageBlob = yield fetch(currentNet).then((res) => res.blob());
                    const netS3Url = yield uploadToImageS3(canvasImageBlob, netS3Key, `Net Image ${index + 1}`);
                    finalNetUrls[index] = netS3Url;
                }
            }
            return {
                previewURL,
                thumbnailURL,
                finalNetUrls,
            };
        }))
            .then(({ previewURL, thumbnailURL, finalNetUrls }) => {
            // Proceed with adding to cart after images have been handled
            const timeStamp = Date.now();
            let addToCartData = [];
            if (upsellItems.length) {
                // Add Upsells Only (Boxes)
                upsellItems.forEach((upsell) => {
                    const upsellInfo = {
                        id: upsell.id,
                        quantity: 1,
                        properties: {
                            _customiser: product.title,
                            _time: timeStamp,
                            _s3_folder: folderNameUid,
                            _proof_image: previewURL,
                            _thumbnail: thumbnailURL,
                        },
                    };
                    if (extrasAdded == true) {
                        // upsellInfo.properties[strings.extra_added_property] = `+${formattedCurrency(baseUnitPrice, false)} ${
                        //   strings.extra_qty_suffix
                        // }`;
                        upsellInfo.properties[strings.extra_added_property] = 'TRUE';
                    }
                    finalNetUrls.forEach((image, index) => {
                        return (upsellInfo.properties[`_final_artwork_${index + 1}`] = image);
                    });
                    addToCartData.push(upsellInfo);
                });
            }
            else {
                // Add Main Cart State (T-Shirts)
                addToCartData = cartState.map((cartItem) => {
                    const cartItemInfo = {
                        id: cartItem.id,
                        quantity: cartItem.quantity,
                        properties: {
                            _customiser: product.title,
                            _time: timeStamp,
                            _s3_folder: folderNameUid,
                            _proof_image: previewURL,
                            _thumbnail: thumbnailURL,
                        },
                    };
                    if (extrasAdded == true) {
                        cartItemInfo.properties[strings.extra_added_property] = `+${formattedCurrency(baseUnitPrice, false)} ${strings.extra_qty_suffix}`;
                    }
                    finalNetUrls.forEach((image, index) => {
                        return (cartItemInfo.properties[`_final_artwork_${index + 1}`] = image);
                    });
                    for (const [side, urls] of Object.entries(uploadedImages)) {
                        urls.forEach((url, index) => {
                            cartItemInfo.properties[`_upload_${side.toLowerCase()}_${index + 1}`] = url;
                        });
                    }
                    if (settings.proofs_only) {
                        cartItemInfo.properties['_proofs_only'] = 'TRUE';
                    }
                    return cartItemInfo;
                });
            }
            cartUtil
                .add(addToCartData)
                .then(() => {
                document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            })
                .then(() => {
                setIsLoading(false);
                // HG-354 Stop page refresh: Disabling for now
                // window.removeEventListener('beforeunload', onConfirmRefresh, true);
                handler();
            })
                .catch(() => {
                setIsLoading(false);
            });
        })
            .then(() => {
            setIsLoading(false);
        })
            .catch((error) => {
            setUploadFailed(true);
            setIsLoading(false);
            console.error('Error adding to cart or uploading images:', error);
        });
    });
    // Upsells
    const upsellContainer = useRef(null);
    const upsellAddedItemsList = useRef(null);
    const upsellAddedItemsListWrapper = useRef(null);
    const columnCount = (_a = product === null || product === void 0 ? void 0 : product.options) === null || _a === void 0 ? void 0 : _a.filter((option) => option.name && !option.name.startsWith('_')).length;
    const [upsellSizeOptionIndex, setUpsellSizeOptionIndex] = useState(null);
    const [upsellQuantityOptionIndex, setUpsellQuantityOptionIndex] = useState(null);
    const [upsellSelectedVariant, setUpsellSelectedVariant] = useState(null);
    const [upsellSelectedVariantSize, setUpsellSelectedVariantSize] = useState(null);
    const [upsellSelectedVariantQty, setUpsellSelectedVariantQty] = useState(null);
    const [upsellSelectedVariantDoubleSidedCostDifference, setUpsellSelectedVariantDoubleSidedCostDifference] = useState(0);
    const [upsellItems, setUpsellItems] = useState([]);
    const [upsellItemsTotal, setUpsellItemsTotal] = useState(0);
    const [upsellItemsTotalSavingsArr, setUpsellItemsTotalSavingsArr] = useState([]);
    const [upsellItemsTotalSavings, setUpsellItemsTotalSavings] = useState(0);
    const [upsellItemsAreDifferentSizes, setUpsellItemsAreDifferentSizes] = useState(false);
    useEffect(() => {
        setUpsellSizeOptionIndex(product.options.findIndex((option) => option.name === 'Size'));
        setUpsellQuantityOptionIndex(product.options.findIndex((option) => option.name === 'Quantity'));
    }, [product]);
    useEffect(() => {
        setUpsellSelectedVariantSize(currentVariant.options[productOptionKeys.indexOf('Size')]);
        setUpsellSelectedVariantQty(currentVariant.options[productOptionKeys.indexOf('Quantity')]);
    }, [currentVariant]);
    useEffect(() => {
        let lowestQty = Infinity;
        let lowestPrice = null;
        const sameSizeAndPrintVariants = [];
        const printOption = extrasAdded ? 'Double' : 'Single';
        product.variants.forEach((variant) => {
            if (variant.options.includes(upsellSelectedVariantSize) && variant.options.includes(printOption)) {
                if (parseInt(variant.options[upsellQuantityOptionIndex]) > 1) {
                    sameSizeAndPrintVariants.push(variant);
                }
            }
        });
        sameSizeAndPrintVariants.forEach((item) => {
            const qty = parseInt(item.options[upsellQuantityOptionIndex]);
            if (qty < lowestQty) {
                lowestQty = qty;
                lowestPrice = item.price / 100;
            }
        });
        if (lowestPrice) {
            setBaseUnitPrice(lowestPrice / lowestQty);
            setBasePricePerItem(lowestPrice);
        }
    }, [
        product,
        upsellSelectedVariant,
        upsellSizeOptionIndex,
        upsellSelectedVariantSize,
        upsellQuantityOptionIndex,
        upsellSelectedVariantQty,
        extrasAdded,
    ]);
    useEffect(() => {
        const options = [upsellSelectedVariantSize, upsellSelectedVariantQty, extrasAdded ? 'Double' : 'Single'];
        const matchingVariant = product.variants.find((variant) => options.every((val) => variant.options.includes(val)));
        if (matchingVariant) {
            setUpsellSelectedVariant(matchingVariant);
        }
    }, [extrasAdded, upsellSelectedVariantSize, upsellSelectedVariantQty]);
    useEffect(() => {
        var _a, _b;
        const total = upsellItems.reduce((sum, currentItem) => {
            return sum + (currentItem.price || 0);
        }, 0);
        setUpsellItemsTotal(total);
        (_a = upsellAddedItemsList === null || upsellAddedItemsList === void 0 ? void 0 : upsellAddedItemsList.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('--height', `${(_b = upsellAddedItemsListWrapper === null || upsellAddedItemsListWrapper === void 0 ? void 0 : upsellAddedItemsListWrapper.current) === null || _b === void 0 ? void 0 : _b.scrollHeight}px`);
    }, [upsellItems]);
    useEffect(() => {
        const optionsForSingleSided = [upsellSelectedVariantSize, `${upsellSelectedVariantQty}`, 'Single'];
        const optionsForDoubleSided = [upsellSelectedVariantSize, `${upsellSelectedVariantQty}`, 'Double'];
        const singleSidedVersion = product.variants.find((variant) => {
            return optionsForSingleSided.every((opt) => variant.options.includes(opt));
        });
        const doubleSidedVersion = product.variants.find((variant) => {
            return optionsForDoubleSided.every((opt) => variant.options.includes(opt));
        });
        if (singleSidedVersion && doubleSidedVersion) {
            const singleUnitCost = singleSidedVersion.price / parseInt(singleSidedVersion.options[upsellQuantityOptionIndex]);
            const doubleUnitCost = doubleSidedVersion.price / parseInt(doubleSidedVersion.options[upsellQuantityOptionIndex]);
            const difference = doubleUnitCost - singleUnitCost;
            setUpsellSelectedVariantDoubleSidedCostDifference(difference);
        }
    }, [upsellSelectedVariantSize, upsellSelectedVariantQty, upsellQuantityOptionIndex]);
    // Total Savings
    useEffect(() => {
        setUpsellItemsTotalSavings(upsellItemsTotalSavingsArr.reduce((acc, curr) => acc + curr, 0));
    }, [upsellItemsTotalSavingsArr]);
    // Different Sizes?
    useEffect(() => {
        var _a;
        if (upsellItems.length === 0) {
            setUpsellItemsAreDifferentSizes(false);
            return;
        }
        const firstOption = (_a = upsellItems[0].options) === null || _a === void 0 ? void 0 : _a[upsellSizeOptionIndex];
        const hasDifference = upsellItems.some((item) => { var _a; return ((_a = item.options) === null || _a === void 0 ? void 0 : _a[upsellSizeOptionIndex]) !== firstOption; });
        setUpsellItemsAreDifferentSizes(hasDifference);
    }, [upsellItems, upsellSizeOptionIndex]);
    // Size Guide
    const [openSizeGuide, setOpenSizeGuide] = useState(false);
    if (!currentSelectedFilter || !filter)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `hg-modal${display ? ' hg-modal--open' : ''}${settings.apply_multiply_effect ? ' hg-modal--multiply' : ''}` },
            React.createElement("div", { className: `hg-modal__loading${isLoading ? ' display' : ''}` },
                React.createElement(Lottie, { options: finalLoader, height: 180, width: 180, isStopped: false, isPaused: false }),
                React.createElement(LoadingText, { text: ['Uploading your designs!', 'Creating your packaging!', "Won't be too long!"] })),
            React.createElement("div", { className: `hg-modal__loading${imageUploading ? ' display' : ''}` },
                React.createElement(Lottie, { options: imageLoader, height: 120, width: 120, isStopped: false, isPaused: false, style: { marginBottom: '40px' } }),
                React.createElement(LoadingText, { text: ['Uploading image!', "Won't be too long!"] })),
            React.createElement("div", { className: "hg-modal__content" },
                React.createElement("div", { className: "hg-modal__container" },
                    React.createElement("div", { className: "hg-modal__row hg-modal__header hg-modal-display" },
                        React.createElement("div", { className: `hg-modal__sides hg-modal__col-left ${currentWindow === 'first' ? 'hg-modal__sides--display' : ''}` },
                            React.createElement("h4", null, strings.choose_your_side_title),
                            React.createElement("div", { className: "hg-modal__sides-wrapper" }, currentVariant.sides.map((sideData, index) => sideData.print_side == 'Single' ? (React.createElement(ProductSideButton, { key: index, currentSide: currentSide, icon: sideData.icon, iconSelected: sideData.icon_selected, side: sideData.side_name, displaySide: displaySide, buttonText: sideData.side_name, customClass: currentVariant.sides.length == 1 ? 'hide-circle' : '' })) : (React.createElement(ExtraSideButton, { key: index, currentSide: currentSide, icon: sideData.icon, iconSelected: sideData.icon_selected, side: sideData.side_name, displaySide: displaySide, buttonText: sideData.side_name, extrasAdded: extrasAdded, removeExtras: removeExtras, strings: strings, unitPrice: upsellSelectedVariant ? upsellSelectedVariantDoubleSidedCostDifference : baseUnitPrice }))))),
                        React.createElement("div", { className: "hg-modal__close hg-modal__col-right" },
                            React.createElement("button", { onClick: handleCloseButtonClick },
                                strings.exit_btn,
                                React.createElement(Close, null)))),
                    React.createElement("div", { className: `hg-modal__row hg-modal__main-content hg-modal__main-content--editting ${currentWindow === 'first' ? 'hg-modal-display' : ''}` }, currentVariant.sides.map((sideData, index) => (React.createElement(ProductSide, { key: index, canvasDimensions: canvasDimensions[sideData.side_name] || null, currentVariant: currentVariant, currentFilter: currentSelectedFilter.options[productOptionKeys.indexOf(filter)], productOptions: product.options, currentSize: currentVariant.options[productOptionKeys.indexOf('Size')], isActive: currentSide === sideData.side_name, filter: filter, globalFolderName: globalFolderName, imageDimensions: imageDimensions[sideData.side_name] || null, imageSpecs: strings.file_size_warning_text, previewLoading: previewLoading, selectedImage: selectedImages[sideData.side_name], settings: settings, sideData: sideData, strings: strings, uploadedImages: uploadedImages[sideData.side_name] || null, calculateCanvasSize: calculateCanvasSize, goToNextScreen: goToNextScreen, handleAlignment: handleAlignment, handleImageRemove: handleImageRemove, handleImageUpload: handleImageUpload, reorderImagesOnSide: reorderImagesOnSide, setImageUploading: setImageUploading, setSelectedImage: setSelectedImagePerSide, updateImageDimensions: updateImageDimensions, updateImageScale: updateImageScale, updatePosition: updatePosition, updateCurrentVariant: updateCurrentVariantInit, upsellItemsAreDifferentSizes: upsellItemsAreDifferentSizes })))),
                    React.createElement("div", { className: `hg-modal__row hg-modal__main-content hg-modal__main-content--preview ${currentWindow === 'second' ? 'hg-modal-display' : ''}` },
                        React.createElement("div", { className: "hg-modal__col-left hg-modal__preview", style: { '--column-count': currentVariant.sides.length == 1 ? 1 : 2 } }, currentVariant.sides.map((sideData, index) => {
                            const customiserWidth = Number(sideData.canvas_width) + Number(sideData.canvas_left) + Number(sideData.canvas_right);
                            const customiserHeight = Number(sideData.canvas_height) + Number(sideData.canvas_top) + Number(sideData.canvas_bottom);
                            return (React.createElement(PreviewTile, { key: index, basePricePerItem: basePricePerItem, baseUnitPrice: upsellSelectedVariant ? upsellSelectedVariantDoubleSidedCostDifference : baseUnitPrice, canvasPreviews: canvasPreviews, customiserHeight: customiserHeight, customiserWidth: customiserWidth, extrasAdded: extrasAdded, sideData: sideData, strings: strings, editImageHandler: editImageHandler, removeExtras: removeExtras }));
                        })),
                        React.createElement("div", { className: "hg-modal__col-right" },
                            React.createElement("div", { className: "hg-modal__col-right--inner" },
                                React.createElement("button", { className: "hg-modal__back", onClick: changeWindowHandler },
                                    React.createElement(BackArrow, null),
                                    strings.back_btn),
                                filter == 'Colour' ||
                                    (filter == 'Color' && React.createElement("h3", { className: "hg-modal__customise-title" }, strings.finalise_title)),
                                filter == 'Quantity' ? (React.createElement(React.Fragment, null,
                                    React.createElement("h4", { className: "hg-modal__current-size hg-modal__current-size--boxes" },
                                        strings.selected_size_label,
                                        React.createElement("span", { className: "hg-modal__current-size--size" }, currentVariant.options[productOptionKeys.indexOf('Size')])),
                                    React.createElement(ProductPrice, { customClass: "hg-modal__price--boxes", selectedPrice: currentSelectedFilter.price, basePricePerItem: basePricePerItem, selectedQty: Number(currentSelectedFilter.options[productOptionKeys.indexOf(filter)]), baseUnitPrice: baseUnitPrice, strings: strings, extrasAdded: extrasAdded, setBaseCurrentVariantSaving: setBaseCurrentVariantSaving }))) : (React.createElement("div", { className: "hg-modal__price" },
                                    React.createElement("p", null,
                                        React.createElement("span", { className: "hg-modal__price--base" }, formattedCurrency(cartPrices.withDiscount == 0 ? currentSelectedFilter.price : cartPrices.withDiscount, false)),
                                        cartPrices.combinedTotal > cartPrices.withDiscount ? (React.createElement(React.Fragment, null,
                                            React.createElement("span", { className: "hg-modal__price--compare" }, formattedCurrency(cartPrices.combinedTotal, false)),
                                            React.createElement("span", { className: "hg-modal__price--savings" },
                                                "(Save ",
                                                Number(cartPrices.discount),
                                                "%)"))) : null),
                                    extrasAdded ? (React.createElement("p", { className: "hg-modal__price--extra-message" },
                                        React.createElement("span", { className: "hg-modal__price--extra-message-price" },
                                            "Includes ",
                                            formattedCurrency(baseUnitPrice, false),
                                            " ",
                                            strings.extra_qty_suffix),
                                        React.createElement("span", { className: "hg-modal__price--extra-message-caption" }, strings.extra_price_label))) : null)),
                                filter == 'Quantity' ? (React.createElement(React.Fragment, null,
                                    React.createElement(SectionTitle, { customClass: "hg-modal__title--boxes", title: "Quantity", rightText: !currentSelectedFilter.options[productOptionKeys.indexOf(filter)].includes('Sample')
                                            ? `${formattedCurrency(currentSelectedFilter.price /
                                                currentSelectedFilter.options[productOptionKeys.indexOf(filter)], false)} per item`
                                            : `${formattedCurrency(currentSelectedFilter.price, false)} per item` }),
                                    React.createElement("div", { className: "hg-modal__quantity hg-modal__quantity--boxes" }, currentFilterOptions.map((qtyButton, index) => extrasAdded
                                        ? qtyButton.options[productOptionKeys.indexOf('_print')] == 'Double' && (React.createElement("button", { key: index, disabled: !qtyButton.available, className: `${currentSelectedFilter == qtyButton ? 'selected' : ''}`, onClick: () => changeQty(qtyButton) }, qtyButton.options[productOptionKeys.indexOf(filter)]))
                                        : qtyButton.options[productOptionKeys.indexOf('_print')] != 'Double' && (React.createElement("button", { key: index, disabled: !qtyButton.available, className: `${currentSelectedFilter == qtyButton ? 'selected' : ''}`, onClick: () => changeQty(qtyButton) }, qtyButton.options[productOptionKeys.indexOf(filter)])))))) : (React.createElement("div", { className: "hg-modal__select-size" },
                                    React.createElement(SectionTitle, { title: templateStrings.hg_size_label_override
                                            ? templateStrings.hg_size_label_override
                                            : strings.size_label, rightText: `${cartState.length
                                            ? formattedCurrency(cartPrices.withDiscount / cartState.reduce((total, item) => total + item.quantity, 0), false)
                                            : formattedCurrency(currentSelectedFilter.price, false)} per item`, modalButton: strings.view_size_guide, sizeGuideContent: settings.product_size_guide_content }),
                                    templateStrings.hg_bulk_discount_message_override || strings.bulk_discount_message ? (React.createElement("p", { className: "bulk-message" }, templateStrings.hg_bulk_discount_message_override
                                        ? templateStrings.hg_bulk_discount_message_override
                                        : strings.bulk_discount_message)) : null,
                                    React.createElement(QuantitySelect, { allVariants: product.variants, currentFilterVariant: currentSelectedFilter.options[productOptionKeys.indexOf(filter)], currentVariant: currentSelectedFilter, currentPrintSide: currentSelectedFilter.options[productOptionKeys.indexOf('_print')], cartState: cartState, sizeIndex: productOptionKeys.indexOf('Size'), updateCartState: updateCartState }))),
                                filter == 'Quantity' && (React.createElement("div", { ref: upsellContainer, className: "hg-modal__upsell" },
                                    React.createElement("div", { className: "upsell__header" },
                                        React.createElement("div", { className: "upsell__title" },
                                            React.createElement("h3", null, "Select your sizes")),
                                        settings.product_size_guide_content && (React.createElement("div", null,
                                            React.createElement("button", { onClick: () => {
                                                    setOpenSizeGuide(true);
                                                } }, strings.view_size_guide)))),
                                    React.createElement("div", { className: "upsell__selects" }, product.options &&
                                        product.options.map((option, optionIndex) => (React.createElement("div", { key: optionIndex, className: `upsell__select ${option.name.startsWith('_') ? `upsell__select--hidden` : ''}` },
                                            React.createElement("label", { htmlFor: `product-option-${optionIndex}`, className: "select__label" }, option.name),
                                            option.values.length &&
                                                (option.name.startsWith('_') ? (React.createElement("select", { id: `product-option-${optionIndex}`, className: "select__input", value: extrasAdded ? 'Double' : 'Single' }, option.values.map((value, valueIndex) => (React.createElement("option", { key: valueIndex }, value))))) : option.name == 'Size' ? (React.createElement("select", { id: `product-option-${optionIndex}`, className: "select__input select__input--size", value: upsellSelectedVariantSize || '', onChange: (event) => setUpsellSelectedVariantSize(event.target.value) },
                                                    React.createElement("option", { disabled: true },
                                                        "Select a ",
                                                        option.name),
                                                    option.values.map((value, valueIndex) => (React.createElement("option", { key: valueIndex }, value))))) : option.name == 'Quantity' ? (React.createElement("select", { id: `product-option-${optionIndex}`, className: "select__input select__input--quanity", value: upsellSelectedVariantQty || '', onChange: (event) => setUpsellSelectedVariantQty(event.target.value) },
                                                    React.createElement("option", { disabled: true },
                                                        "Select a ",
                                                        option.name),
                                                    option.values.map((value, valueIndex) => (React.createElement("option", { key: valueIndex }, value))))) : (React.createElement("select", { id: `product-option-${optionIndex}`, className: "select__input" },
                                                    React.createElement("option", { disabled: true },
                                                        "Select a ",
                                                        option.name),
                                                    option.values.map((value, valueIndex) => (React.createElement("option", { key: valueIndex }, value)))))))))),
                                    React.createElement("div", { className: "upsell__selected-variant-savings" }, upsellSelectedVariant && upsellSelectedVariantQty && (React.createElement(React.Fragment, null,
                                        React.createElement("div", null,
                                            React.createElement(ProductPrice, { selectedPrice: upsellSelectedVariant.price, basePricePerItem: basePricePerItem, selectedQty: upsellSelectedVariantQty, baseUnitPrice: baseUnitPrice, strings: strings, extrasAdded: false, setBaseCurrentVariantSaving: setBaseCurrentVariantSaving })),
                                        React.createElement("div", null,
                                            formattedCurrency(upsellSelectedVariant.price / upsellSelectedVariantQty, false),
                                            " per unit")))),
                                    upsellItemsAreDifferentSizes || true ? (React.createElement("div", { className: "upsell__size-message" },
                                        React.createElement("div", { className: "size-message__icon" },
                                            React.createElement("svg", { width: "54", height: "54", viewBox: "0 0 54 54", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                                React.createElement("path", { d: "M26.8398 50.3121C39.5811 50.3121 49.91 39.934 49.91 27.1319C49.91 14.3298 39.5811 3.95166 26.8398 3.95166C14.0984 3.95166 3.76953 14.3298 3.76953 27.1319C3.76953 39.934 14.0984 50.3121 26.8398 50.3121Z", fill: "#7CAE76", stroke: "#7CAE76", strokeWidth: "6.74614", strokeLinecap: "round", strokeLinejoin: "round" }),
                                                React.createElement("path", { d: "M26.8164 25.0234V39.7745", stroke: "white", strokeWidth: "6.74614", strokeLinecap: "round", strokeLinejoin: "round" }),
                                                React.createElement("ellipse", { cx: "26.8041", cy: "15.5423", rx: "3.14594", ry: "3.16094", fill: "white" }))),
                                        React.createElement("div", { className: "size-message__content" },
                                            React.createElement("p", null, "All sizes in this order will use the same design"),
                                            React.createElement("p", null, "You can add multiple sizes and your discount will apply to the combined total.")))) : null,
                                    React.createElement("div", { className: `upsell__add-to-order ${upsellSelectedVariant ? '' : 'upsell__add-to-order--disabled'}` },
                                        React.createElement("button", { onClick: () => {
                                                setUpsellItems((prev) => [...prev, upsellSelectedVariant]);
                                                setUpsellItemsTotalSavingsArr((prevItems) => [...prevItems, baseCurrentVariantSaving]);
                                            } }, upsellSelectedVariant ? 'Add to order' : 'Select options')),
                                    upsellItems.length ? (React.createElement(React.Fragment, null,
                                        React.createElement("div", { className: "upsell__sub-title" },
                                            React.createElement("h3", null, "Finalise your order")),
                                        React.createElement("div", { ref: upsellAddedItemsList, className: "upsell__added-items" },
                                            React.createElement("div", { ref: upsellAddedItemsListWrapper },
                                                React.createElement("table", null,
                                                    React.createElement("tbody", null,
                                                        React.createElement("tr", null,
                                                            product.options.map((option, optionIndex) => option.name && !option.name.startsWith('_') ? (React.createElement("th", { key: optionIndex }, option.name)) : null),
                                                            React.createElement("th", { colSpan: 2 }, "Price")),
                                                        upsellItems.map((item, itemIndex) => (React.createElement("tr", { key: itemIndex, className: "upsell__added-item" },
                                                            product.options.map((option, optionIndex) => {
                                                                var _a, _b;
                                                                return option.name && !option.name.startsWith('_') ? (React.createElement(React.Fragment, null,
                                                                    React.createElement("td", { className: "added-item__variant-option", key: optionIndex },
                                                                        React.createElement("span", null,
                                                                            ' ',
                                                                            ((_a = item.options) === null || _a === void 0 ? void 0 : _a[optionIndex])
                                                                                ? `${(_b = item.options) === null || _b === void 0 ? void 0 : _b[optionIndex]}`
                                                                                : '',
                                                                            ' ')))) : null;
                                                            }),
                                                            React.createElement("td", { className: "added-item__price" }, formattedCurrency(item.price, false)),
                                                            React.createElement("td", { className: "added-item__remove" },
                                                                React.createElement("button", { onClick: () => {
                                                                        setUpsellItems((prevItems) => prevItems.filter((_, i) => i !== itemIndex));
                                                                        setUpsellItemsTotalSavingsArr((prevItems) => prevItems.filter((_, i) => i !== itemIndex));
                                                                    } },
                                                                    React.createElement("span", null, "Remove"),
                                                                    React.createElement("svg", { width: "14", height: "13", viewBox: "0 0 14 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                                                        React.createElement("g", { id: "Group 418" },
                                                                            React.createElement("path", { id: "Vector 22", d: "M13 0.5L1 12.5", stroke: "#37404A" }),
                                                                            React.createElement("path", { id: "Vector 23", d: "M0.999999 0.500001L13 12.5", stroke: "#37404A" })))))))),
                                                        upsellItemsTotalSavings > 0 ? (React.createElement("tr", { className: "upsell__total-savings" },
                                                            React.createElement("td", { colSpan: columnCount }, "Total Savings"),
                                                            React.createElement("td", null, formattedCurrency(upsellItemsTotalSavings, false)))) : null),
                                                    React.createElement("tfoot", null,
                                                        React.createElement("tr", null,
                                                            React.createElement("td", { colSpan: columnCount },
                                                                "Total",
                                                                extrasAdded ? (React.createElement("p", { className: "totals__extra-message" },
                                                                    React.createElement("span", { className: "extra-message__caption" }, strings.extra_price_label))) : null),
                                                            React.createElement("td", { colSpan: 2 }, formattedCurrency(upsellItemsTotal, false))))))))) : null)),
                                filter == 'Quantity' ? (upsellItems.length ? (React.createElement(React.Fragment, null,
                                    React.createElement(Checkbox, { label: strings.confirmation_checkbox_text, setIsCheckboxChecked: setIsCheckboxChecked, isCheckboxChecked: isCheckboxChecked }),
                                    React.createElement("button", { className: "hg-modal__next hg-modal__next--upsell", onClick: initAddToCart, disabled: !isCheckboxChecked || cartCombinedQty < settings.min_order_qty }, isLoading
                                        ? 'loading'
                                        : `${strings.add_to_cart_btn} | ${formattedCurrency(upsellItemsTotal, false)}`))) : null) : (React.createElement(React.Fragment, null,
                                    React.createElement(Checkbox, { label: strings.confirmation_checkbox_text, setIsCheckboxChecked: setIsCheckboxChecked, isCheckboxChecked: isCheckboxChecked }),
                                    React.createElement("button", { className: "hg-modal__next", onClick: initAddToCart, disabled: !isCheckboxChecked || cartCombinedQty < settings.min_order_qty }, isLoading
                                        ? 'loading'
                                        : cartPrices.withDiscount == 0
                                            ? strings.atc_btn_nothing_selected
                                            : `${strings.add_to_cart_btn} | ${formattedCurrency(cartPrices.withDiscount, false)}`))),
                                filter != 'Quantity' && settings.enable_hg_c_disc ? (React.createElement("div", { className: "hg-modal__tiered-discount-table" },
                                    React.createElement("table", null,
                                        React.createElement("tr", null,
                                            React.createElement("th", null, strings.quantity),
                                            React.createElement("th", null, strings.unit_price),
                                            React.createElement("th", null, strings.discount)),
                                        React.createElement("tr", null,
                                            React.createElement("td", null,
                                                settings.tier_one_qty,
                                                "+"),
                                            React.createElement("td", null, formattedCurrency(currentSelectedFilter.price * ((100 - settings.tier_one_disc) / 100), false)),
                                            React.createElement("td", null,
                                                settings.tier_one_disc,
                                                "%")),
                                        settings.tier_two_enable ? (React.createElement("tr", null,
                                            React.createElement("td", null,
                                                settings.tier_two_qty,
                                                "+"),
                                            React.createElement("td", null, formattedCurrency(currentSelectedFilter.price * ((100 - settings.tier_two_disc) / 100), false)),
                                            React.createElement("td", null,
                                                settings.tier_two_disc,
                                                "%"))) : null,
                                        settings.tier_three_enable ? (React.createElement("tr", null,
                                            React.createElement("td", null,
                                                settings.tier_three_qty,
                                                "+"),
                                            React.createElement("td", null, formattedCurrency(currentSelectedFilter.price * ((100 - settings.tier_three_disc) / 100), false)),
                                            React.createElement("td", null,
                                                settings.tier_three_disc,
                                                "%"))) : null,
                                        settings.tier_four_enable ? (React.createElement("tr", null,
                                            React.createElement("td", null,
                                                settings.tier_four_qty,
                                                "+"),
                                            React.createElement("td", null, formattedCurrency(currentSelectedFilter.price * ((100 - settings.tier_four_disc) / 100), false)),
                                            React.createElement("td", null,
                                                settings.tier_four_disc,
                                                "%"))) : null,
                                        settings.tier_five_enable ? (React.createElement("tr", null,
                                            React.createElement("td", null,
                                                settings.tier_five_qty,
                                                "+"),
                                            React.createElement("td", null, formattedCurrency(currentSelectedFilter.price * ((100 - settings.tier_five_disc) / 100), false)),
                                            React.createElement("td", null,
                                                settings.tier_five_disc,
                                                "%"))) : null))) : null))),
                    ((_b = netImageData[0]) === null || _b === void 0 ? void 0 : _b.images.length) ? (React.createElement("div", { className: "hg-modal__nets", ref: netRef }, netImageData.map((net, index) => (React.createElement(FinalNets, { key: index, netIndex: index + 1, images: net.images, widthMM: Number(net.width), heightMM: Number(net.height), multiplier: settings.file_output_type == 'PDF' ? 8 : settings.proofs_only ? 0.3 : 2 }))))) : null,
                    React.createElement("div", { className: "hg-modal__export-canvases" }, currentVariant.sides.map((side, index) => (React.createElement(ExportCanvas, { key: index, canvasIndex: index + 1, sideName: side.side_name, canvasWidthMM: Number(side.canvas_width), canvasHeightMM: Number(side.canvas_height), uploadedImages: uploadedImages[side.side_name] || null, scaleMultiplier: scaleMultiplier[side.side_name], imageDimensions: imageDimensions[side.side_name] || null, selectedImage: selectedImages[side.side_name], pxConverter: settings.file_output_type == 'PDF' ? 10 : settings.proofs_only ? 0.5 : 1, canvasRef: finalCanvasRefs.current[index] })))),
                    React.createElement("div", { className: "hg-modal__preview-canvas", style: { '--column-count': currentVariant.sides.length == 1 ? 1 : 2 }, "data-hg-preview-canvas": "" }, currentVariant.sides.map((sideData, index) => {
                        const customiserWidth = Number(sideData.canvas_width) + Number(sideData.canvas_left) + Number(sideData.canvas_right);
                        const customiserHeight = Number(sideData.canvas_height) + Number(sideData.canvas_top) + Number(sideData.canvas_bottom);
                        return (React.createElement("div", { key: index, className: `hg-preview-canvas${sideData.print_side == 'Double' ? ' extra' : ''}${extrasAdded ? ' extra-added' : ''}` },
                            React.createElement("div", { className: "hg-preview-canvas__base-image-wrapper", style: { aspectRatio: `${customiserWidth} / ${customiserHeight}` } },
                                React.createElement("img", { src: sideData.image, alt: sideData.side_name, className: "hg-preview-canvas__base-image" }),
                                canvasPreviews[sideData.side_name] && (React.createElement("img", { className: `hg-preview-canvas__canvas-image${settings.apply_multiply_effect ? ' multiply' : ''}`, 
                                    // @ts-ignore
                                    style: {
                                        top: `${(Number(sideData.canvas_top) / customiserHeight) * 100}%`,
                                        left: `${(Number(sideData.canvas_left) / customiserWidth) * 100}%`,
                                        width: `${(Number(sideData.canvas_width) / customiserWidth) * 100}%`,
                                    }, src: canvasPreviews[sideData.side_name], alt: `Preview of ${sideData.side_name}` }))),
                            React.createElement("div", { className: "hg-preview-canvas__name" },
                                React.createElement("p", null, sideData.side_name))));
                    }))),
                openSizeGuide && settings.product_size_guide_content && (React.createElement(ErrorPopupLayout, null,
                    React.createElement("button", { className: "hg-modal__warning--close", "aria-label": "close", onClick: () => {
                            setOpenSizeGuide(false);
                        } },
                        React.createElement(Close, null)),
                    React.createElement("div", { className: "hg-modal__page-content", dangerouslySetInnerHTML: { __html: settings.product_size_guide_content } })))),
            fileTypeError.isError && (React.createElement(FileSizePopup, Object.assign({ handleReset: resetErrorChecks, warningType: "fileType" }, strings))),
            fileSizeError.isError && (React.createElement(FileSizePopup, Object.assign({ handleReset: resetErrorChecks, warningType: "fileSize" }, strings))),
            fileLargeError.isError && (React.createElement(FileSizePopup, Object.assign({ handleReset: resetErrorChecks, warningType: "fileLarge" }, strings))),
            fileSmallError.isError && (React.createElement(FileSizePopup, Object.assign({ handleReset: resetErrorChecks, warningType: "fileSmall" }, strings))),
            uploadFailed && (React.createElement(FileSizePopup, Object.assign({ handleReset: resetErrorChecks, warningType: "fileUpload" }, strings))),
            maxUploadsError.isError && (React.createElement(FileSizePopup, Object.assign({ handleReset: resetErrorChecks, warningType: "maxUploads" }, strings))),
            React.createElement(WarningPopup, Object.assign({}, strings, { handleDisplay: showWarningPopup, globalFolderName: globalFolderName, deleteFolderContents: deleteFolderContents, closeModal: closeModalAndReset, onCloseWarning: closeWarningPopup })))));
};
export default CustomiseModal;
